<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-团队奖励-添加
    -->
    <el-dialog
    title="添加团队奖励"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
         
      
        <el-form-item label="业绩下限(元)">

                   <el-input-number 
                      v-model="form.min" 
                      :min="0" 
                      :precision="2" 
                      :controls="false"
                      style="width: 100%"
                    ></el-input-number>
            </el-form-item>
                
                <!-- 业绩上限 -->
              <el-form-item label="业绩上限(元)">
                <el-input-number 
                      v-model="form.max" 
                      :min="form.min" 
                      :precision="2" 
                      :controls="false"
                      style="width: 100%"
                  ></el-input-number>
                </el-form-item>
                
                
                <!-- 奖励比例 -->
               <el-form-item label="奖励比例(%)">
                   <el-input-number 
                      v-model="form.rate" 
                      :min="0" 
                      :max="100" 
                      :precision="2" 
                      :controls="false"
                      style="width: 100%"
                    ></el-input-number>
                </el-form-item>

                <el-form-item  label="备注"  >
                    <div>
                      <div v-if="form.min > 0 && form.max > 0 && form.rate > 0">当月链条业绩≥{{form.min}}元且小于{{form.max}}，奖励链条业绩的{{form.rate}}%；</div>
                      <div v-if="form.min == 0 && form.max > 0 && form.rate > 0">当月链条业绩≥{{form.max}}，奖励链条业绩的{{form.rate}}%；</div>
                    </div>
                </el-form-item>

  
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
   </div>
</el-dialog>
  
</template>

<script>
import Team_awardApi from '@/api/team_award.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        max:0,
        min:0,
        rate:0,

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入团队奖励名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Team_awardApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },



  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/team_award/index/part/add.vue